// src/pages/ContactUsPage.jsx
import React, { useState, useEffect } from "react";
import { useLocale } from "../contexts/LocaleContext";
import { getContactUsPageData } from "../api/apiService";
import PageBanner from "../components/common/PageBanner";
import ContactInfoAndMap from "../components/contact/ContactInfoAndMap";
import EnquiryForm from "../components/contact/EnquiryForm";

function ContactUsPage() {
  const { locale } = useLocale();
  const [contactPageData, setContactPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPageData = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getContactUsPageData(locale);
        setContactPageData(data);
      } catch (err) {
        setError(err.message || "Failed to load content.");
        setContactPageData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchPageData();
  }, [locale]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[calc(100vh-200px)]">
        <p className="text-xl text-gray-500">Loading...</p>
      </div>
    );
  }
  if (error) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-red-500 text-xl">Error: {error}</p>
      </div>
    );
  }
  if (!contactPageData) {
    const message = error
      ? error
      : `Contact Page not found or content is unavailable.`;
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-gray-700 text-xl">{message}</p>
      </div>
    );
  }

  const {
    banner,
    logo,
    address,
    address_link,
    phone_num,
    fax_num,
    whatsapp_num,
    email,
    opening_time,
    lat,
    lng,
    title_in_map,
    online_enquiry,
  } = contactPageData;

  return (
    <div className="bg-gray-50 min-h-screen">
      {" "}
      <PageBanner
        title={banner?.title}
        imageUrl={banner?.image?.url}
        titleColorIsWhite={banner?.titleColorIsWhite ?? true}
        bannerHeightClass="h-52 sm:h-60 md:h-64 lg:h-72"
      />
      <ContactInfoAndMap
        logoUrl={logo?.url ? `${logo.url}` : null}
        logoAlt={logo?.alternativeText || "Aqutek Asia Limited"}
        address={address}
        addressLink={address_link}
        phone={phone_num}
        fax={fax_num}
        whatsapp={whatsapp_num}
        email={email}
        openingTime={opening_time}
        mapLat={lat}
        mapLng={lng}
        mapTitle={title_in_map}
        currentLocale={locale}
      />
      {online_enquiry && (
        <EnquiryForm enquiryData={online_enquiry} locale={locale} />
      )}
    </div>
  );
}

export default ContactUsPage;
